var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUpdating = function SvgUpdating(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 23c6.018 0 11-4.982 11-11 0-6.007-4.993-11-11.01-11C5.981 1 1 5.993 1 12c0 6.018 4.993 11 11 11M8.01 8.441c-.388-.41-.27-.992.27-1.423.96-.788 2.35-1.273 3.742-1.273 3.17 0 5.672 2.125 6.222 5.22h1.11c.53 0 .626.496.346.895l-1.78 2.502c-.323.442-.84.41-1.143 0l-1.8-2.502c-.28-.4-.173-.895.345-.895h1.24c-.496-1.974-2.33-3.462-4.54-3.462-1.079 0-1.877.345-2.675.96-.442.323-.949.399-1.337-.022M4.3 12.097l1.78-2.513c.323-.431.84-.41 1.143 0l1.8 2.513c.28.4.173.895-.345.895H7.503c.496 1.963 2.33 3.451 4.54 3.451 1.079 0 1.877-.334 2.675-.949.442-.334.949-.399 1.337.022.399.41.27.992-.27 1.412-.96.799-2.35 1.284-3.742 1.284-3.17 0-5.672-2.125-6.222-5.22H4.645c-.528 0-.625-.496-.345-.895"
  })));
};
export default SvgUpdating;